import type { Tone } from '../ui/Badge';

/**
 * A person's face on the crew map's UI: their initials, ringed in their STATE's tone
 * (`badge--*` sets `--badge-hue` in theme.css), never a colour of their own [Q3]. The chips
 * and the panel's header draw the same face; the map's own markers draw it as markup
 * (`peopleLayer.ts`), since Leaflet owns that DOM.
 *
 * Decorative (`aria-hidden`): whatever holds it says the name and the state in words.
 */
export function Face({
  text,
  tone,
  size = 'sm',
}: {
  text: string;
  tone: Tone;
  size?: 'sm' | 'md';
}) {
  return (
    <span
      aria-hidden="true"
      style={{ color: 'var(--sw-text)' }}
      className={`badge--${tone} grid shrink-0 place-items-center rounded-full border-[3px] border-[var(--badge-hue)] bg-surface font-bold ${
        size === 'md' ? 'size-9 text-xs' : 'size-7 text-[10px]'
      }`}
    >
      {text}
    </span>
  );
}
